import React from "react";
import { Container } from "react-bootstrap";

const PitchBV = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">
            Business Valuation Based on Discounted Cash Flows
          </p>
          {/* first table */}
          <div className="scroll-x">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>01</th>
                <th>02</th>
                <th>03</th>
                <th>04</th>
                <th>05</th>
              </tr>
            </thead>
            <tbody>
              <tr className="lead-row">
                <td>Profit</td>
                <td> $2,552,274,039</td>
                <td> $15,410,431,575</td>
                <td> $37,736,354,520</td>
                <td> $64,340,361,720</td>
                <td> $107,561,907,000</td>
              </tr>
              <tr>
                <td>Depreciation</td>
                <td> $2,520,000</td>
                <td> $9,000,000</td>
                <td> $17,640,000</td>
                <td> $26,280,000</td>
                <td> $36,360,000</td>
              </tr>
              <tr>
                <td>Changes in Work..</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Loans paid back</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>New loans taken</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
             
              <tr>
                <td>Free Cash Flow to Equity (FCFE)</td>
                <td> $2,554,794,039</td>
                <td> $15,419,431,575</td>
                <td> $37,753,994,520</td>
                <td> $64,366,641,720</td>
                <td> $107,598,267,000</td>
              </tr>
              	  	  	  	  	  
              <tr>
                <td>Present Value of FCFE</td>
                <td> $ 2,343,847,742</td>
                <td> $ 12,978,227,064</td>
                <td> $ 29,153,010,875</td>
                <td> $ 45,598,951,746</td>
                <td> $ 69,931,490,835</td>
              </tr>
              {/* <tr className="light-bg">
                <td></td>
              </tr> */}
              <tr>
                <td>Total Present Value of FCFE</td>
                <td> $2,343,847,742</td>
                <td> $15,322,074,806</td>
                <td> $44,475,085,681</td>
                <td> $90,074,037,427</td>
                <td> $160,005,528,262</td>
              </tr>
              <tr>
                <td>Terminal Value</td>
                <td> $2,343,847,742</td>
                <td> $27,124,494,564</td>
                <td> $95,566,484,948</td>
                <td> $208,529,888,599</td>
                <td> $418,519,735,171</td>
              </tr>
              <tr>
                <td>Present Value of Terminal Value</td>
                <td> $2,150,319,030</td>
                <td> $22,830,144,402</td>
                <td> $73,794,860,925</td>
                <td> $147,727,830,344</td>
                <td> $272,009,111,673</td>
              </tr>
              <tr>
                <td className="lead-cell">Business Value</td>
                <td className="active start-cell"> $4,494,166,772</td>
                <td className="active"> $38,152,219,209</td>
                <td className="active"> $118,269,946,606</td>
                <td className="active"> $237,801,867,772</td>
                <td className="active"> $432,014,639,935</td>
              </tr>
            </tbody>
          </table>
          </div>
          {/* seconde table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                  <th>Terminal Value</th>
                </tr>
              </thead>
              <tbody>
                <tr className="active">
                  <td>Interest Incurred</td>
                  <td> $98,714,006,422</td>
                  <td> $90,563,308,644</td>
                  <td> $83,085,604,261</td>
                  <td> $76,225,325,010</td>
                  <td> $69,931,490,835</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchBV;
